import { Navigate } from "react-router-dom";
import {  useSelector } from 'react-redux'


function PrivateRoute({children}) {
let {user} = useSelector(e=>e.auth)

if(!user){
   return <Navigate to="/login" />
}
return children
}

export default PrivateRoute;
